import React from "react";

import { useAutocompleteSuggestions } from "./hooks/useAutocompleteSuggestions";
import { AutocompleteSuggestions } from "../AutocompleteSuggestions";
import { Input, InputProps } from "../Input";

import "./styles.scss";
interface InputWithAutocompleteProps extends InputProps {
  // Autocomplete formula is declared as async in case there is a need to ping the API etc.
  // However, synchronous functions wrapped in a promise are also valid.
  autoCompleteFormula: (input: string) => Promise<string[]>;
  debounceWait?: number;
  maxWait?: number;
}

export const InputWithAutocomplete = (props: InputWithAutocompleteProps) => {
  const {
    name,
    autoCompleteFormula,
    debounceWait = 300,
    maxWait = 1000,
    ...rest
  } = props;

  const { suggestions, onSelectSuggestion } = useAutocompleteSuggestions(
    name,
    autoCompleteFormula,
    debounceWait,
    maxWait
  );

  return (
    <div className="hook-form-input-with-autocomplete">
      <Input name={name} {...rest} />
      <AutocompleteSuggestions
        suggestions={suggestions}
        onSelectSuggestion={onSelectSuggestion}
      />
    </div>
  );
};
